/* React */
import React from 'react';

/* Translation */
import { useTranslation } from 'react-i18next';

/* Styled Components */
import {
  Dots,
  Overlay,
  ItemDropdown,
  ClassroomDetailsListItem,
  ClassroomDetailsListItemImg,
  ClassroomDetailsListThirdColumn,
  ClassroomDetailsListFirstColumn,
  ClassroomDetailsListSecondColumn,
  ClassroomDetailsListItemDropdown,
  ClassroomDetailsListFirstColumnImageName,
} from './styles/ClassroomDetails';

/* Components */
import { Dropdown, Checkbox } from 'lego-dist';
import Tooltip from '../Staff/Manage/Tooltip';
import RendererIf from 'components/RendererIf';

/* Constants, Hooks, Services */
import useCurrentUser from 'hooks/useCurrentUser';
import { ActionPermission } from 'lib/specialPermissions';

interface ClassroomDetailsListItemComponentProps {
  item: any;
  defaultItemAvatar?: any;
  onClickDetailsItem: Function;
  onDeleteDetailsItem: Function;
  onSelectItem: Function;
  selectedItems: any;
  withCheckboxItems?: boolean;
}

const ClassroomDetailsListItemComponent: React.FC<ClassroomDetailsListItemComponentProps> = ({
  item,
  onSelectItem,
  selectedItems,
  defaultItemAvatar,
  onClickDetailsItem,
  onDeleteDetailsItem,
  withCheckboxItems = false,
}) => {
  const {
    name,
    email = 'N/A',
    type = 'N/A',
    parents = [],
    logo = defaultItemAvatar,
    id,
    role_alias,
  } = item;
  const { t: translate } = useTranslation();
  const { can } = useCurrentUser();
  const canDelete = can(ActionPermission.ADD_EDIT_DELETE_STUDENTS);

  /* shorten strung to only display max. 70 characters */
  const truncateString = (str = '', length: number) => {
    if (str.length <= length) return str;
    return `${str.slice(0, length) }...`;
  };

  const onClickItem = () => {
    onClickDetailsItem(id);
  };

  const [parent] = parents.filter((parent: any) => parent.main_parent);

  return (
    <ClassroomDetailsListItem>
      <ClassroomDetailsListFirstColumn>
        {withCheckboxItems ? (
          <Checkbox
            label=" "
            name="permissions"
            checked={selectedItems[id]}
            onChange={() => onSelectItem({ selectedItem: item })}
          />
        ) : (
          <></>
        )}
        <ClassroomDetailsListFirstColumnImageName onClick={onClickItem}>
          {logo && <ClassroomDetailsListItemImg src={logo} />}
          <p>{truncateString(name, 70)}</p>
        </ClassroomDetailsListFirstColumnImageName>
      </ClassroomDetailsListFirstColumn>
      <ClassroomDetailsListSecondColumn onClick={onClickItem}>
        {parent?.name ? (
          <span>
            <Tooltip text={`${parent?.name} ${parent?.lastname}`} />
          </span>
        ) : (
          <Tooltip text={ role_alias || type} />
        )}
      </ClassroomDetailsListSecondColumn>
      <ClassroomDetailsListThirdColumn onClick={onClickItem}>
        <span>
          <Tooltip text={truncateString(parent?.email || email, 20)} />
        </span>
      </ClassroomDetailsListThirdColumn>
      <RendererIf condition={canDelete}>
        <ClassroomDetailsListItemDropdown>
          <Dropdown
            contentWidth={100}
            noPaddingContent
            content={({ close }: any) => (
              <>
                <Overlay onClick={() => close()} />
                <ItemDropdown>
                  <span
                    onClick={() => {
                      onClickItem();
                      close();
                    }}
                  >
                    {translate('common:DETAILS')}
                  </span>
                  <span
                    className="delete"
                    onClick={() => {
                      onDeleteDetailsItem(id);
                      close();
                    }}
                  >
                    {translate('settings:DELETE')}
                  </span>
                </ItemDropdown>
              </>
            )}
            showIndicator={false}
            title={() => <Dots />}
          />
        </ClassroomDetailsListItemDropdown>
      </RendererIf>
    </ClassroomDetailsListItem>
  );
};

export default ClassroomDetailsListItemComponent;
